import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { FaWhatsapp } from 'react-icons/fa'
import { IoDocumentTextOutline, IoPersonOutline } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'
import { URL } from '../../config/url'
import { whatsappNumber } from '../../utilities/birthdays'
import { formatNumber, LIST_PREVIEW_SIZE } from '../../utilities/dashboard'
import { CardTitle } from './InfoButton'

// WhatsApp sem texto pronto, com a mesma montagem de número dos Aniversariantes (celular primeiro; o fixo só com 11 dígitos).
// link: link pronto (Parabenizar, com a mensagem configurada)
export const WhatsappButton = ({ paciente, link, label = 'WhatsApp' }) => {
  const number = whatsappNumber(paciente)
  const href = link || (number ? `https://wa.me/${number}` : null)
  if (!href) return <span className='dashboard-list-muted'>sem celular</span>

  return (
    <Button variant='outline-success' size='sm' className='dashboard-row-button' href={href} target='_blank' rel='noopener noreferrer' title='Abrir a conversa no WhatsApp'>
      <FaWhatsapp aria-hidden='true' /> {label}
    </Button>
  )
}

// Abrir prontuário ou, sem prontuário vinculado, o prontuário mais recente do paciente (latestProntuarioId, com o aviso no
// title); sem nenhum, abrir paciente
export const OpenButton = ({ prontuarioId, latestProntuarioId, pacienteId }) => {
  const navigate = useNavigate()
  const id = prontuarioId || latestProntuarioId
  if (!id && !pacienteId) return null

  return (
    <Button
      variant='outline-primary'
      size='sm'
      className='dashboard-row-button'
      title={(!prontuarioId && latestProntuarioId) ? 'Abre o prontuário mais recente do paciente: o agendamento não tem prontuário vinculado' : undefined}
      onClick={() => navigate(id ? `${URL.prontuario_cadastro}/${id}` : `${URL.pacientes_cadastro}/${pacienteId}`)}
    >
      {id ? 'Abrir prontuário' : 'Abrir paciente'}
    </Button>
  )
}

// Prontuário: o cadastro do prontuário, o mesmo destino do "Abrir prontuário". Só o ícone, ao lado dos botões da linha.
// Sem prontuário vinculado, o prontuário mais recente do paciente (latestProntuarioId), e o nome do botão diz isso
export const ProntuarioButton = ({ prontuarioId, latestProntuarioId }) => {
  const navigate = useNavigate()
  const id = prontuarioId || latestProntuarioId
  if (!id) return null
  const label = prontuarioId ? 'Ver prontuário' : 'Ver prontuário mais recente do paciente'

  return (
    <Button
      variant='outline-primary'
      size='sm'
      className='dashboard-row-button dashboard-icon-button'
      aria-label={label}
      title={label}
      onClick={() => navigate(`${URL.prontuario_cadastro}/${id}`)}
    >
      <IoDocumentTextOutline aria-hidden='true' />
    </Button>
  )
}

// Dados do paciente: o cadastro, o mesmo destino do "Abrir paciente". Só o ícone, ao lado dos botões da linha
export const PacienteButton = ({ pacienteId }) => {
  const navigate = useNavigate()
  if (!pacienteId) return null

  return (
    <Button
      variant='outline-primary'
      size='sm'
      className='dashboard-row-button dashboard-icon-button'
      aria-label='Ver dados do paciente'
      title='Ver dados do paciente'
      onClick={() => navigate(`${URL.pacientes_cadastro}/${pacienteId}`)}
    >
      <IoPersonOutline aria-hidden='true' />
    </Button>
  )
}

const ListRow = ({ row }) => (
  <li>
    <span className={`dashboard-list-lead${row.leadWide ? ' dashboard-list-lead-wide' : ''}`}>{row.lead}</span>
    <span className='dashboard-list-name'>
      {row.name}
      {row.detail ? <small>{row.detail}</small> : ''}
    </span>
    <span className='dashboard-list-actions'>{row.actions}</span>
  </li>
)

// Lista de ação da aba Geral: até 5 linhas e "Ver todos (N)", que abre um modal com até 100 (o total é sempre o número cheio).
// renderItem(item) -> { key, lead, name, detail, actions }. info: chave do INDICATOR_INFO (o "i" ao lado do título)
const ActionList = ({ title, info, subtitle, total, items, renderItem, emptyText, header, footer, showCount = true, wide = false }) => {
  const [showAll, setShowAll] = useState(false)
  const rows = (items || []).map(renderItem)
  const preview = rows.slice(0, LIST_PREVIEW_SIZE)

  return (
    <section className={`dashboard-card dashboard-list-card ${wide ? 'dashboard-card-wide' : ''}`} aria-label={title}>
      <div className='dashboard-card-head dashboard-card-head-count'>
        <div className='dashboard-card-heading'>
          <CardTitle title={title} info={info} />
          {subtitle ? <p className='dashboard-card-sub'>{subtitle}</p> : ''}
        </div>
        {showCount ? <span className='dashboard-count'>{formatNumber(total)}</span> : ''}
      </div>

      {header || ''}

      {rows.length ?
        <ul className='dashboard-list'>{preview.map((row) => <ListRow key={row.key} row={row} />)}</ul>
        :
        <p className='dashboard-empty'>{emptyText}</p>
      }

      {(total > preview.length) ?
        <button type='button' className='dashboard-link-button mt-2' onClick={() => setShowAll(true)}>Ver todos ({formatNumber(total)})</button>
        : ''}
      {footer || ''}

      <Modal show={showAll} onHide={() => setShowAll(false)} size='lg' scrollable>
        <Modal.Header closeButton>
          <Modal.Title as='h5'>{title} ({formatNumber(total)})</Modal.Title>
        </Modal.Header>
        <Modal.Body className='dashboard-list-modal'>
          <ul className='dashboard-list'>{rows.map((row) => <ListRow key={row.key} row={row} />)}</ul>
          {(total > rows.length) ? <p className='dashboard-card-note mt-2 mb-0'>Mostrando {formatNumber(rows.length)} de {formatNumber(total)}.</p> : ''}
        </Modal.Body>
      </Modal>
    </section>
  )
}

export default ActionList
